var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertTriangle = function SvgAlertTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 8a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1m0 8a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2zM10.528 2.283a3 3 0 0 1 4.037 1.059l.003.004 8.47 14.14.008.014A3 3 0 0 1 20.48 22H3.519a3 3 0 0 1-2.565-4.5l.008-.014 8.47-14.14.003-.004a3 3 0 0 1 1.093-1.059m.618 2.094L2.682 18.506A1 1 0 0 0 3.536 20h16.927a1 1 0 0 0 .854-1.494L12.855 4.379l-.001-.002a1 1 0 0 0-1.708 0"
  })));
};
export default SvgAlertTriangle;